import { inject, observer } from "mobx-react";
import queryString from "querystring";
import React from "react";
import WalletService from "../../core/services/wallet";
import fire from "../../fire";
import AppStore from "../../Store";
import QuestionPage from "../question/question";
import "./home.scss";

@inject("appStore")
@observer
export default class HomePage extends React.Component<{
  appStore: AppStore;
  history: any;
  location: Location;
}> {
  private walletService: WalletService = new WalletService();

  async componentDidMount(): Promise<void> {
    this.props.appStore.answerId = undefined;
    this.props.appStore.questionId = undefined;
    this.props.appStore.isOfferAccepting = false;
    this.checkWalletLogin();
    fire.analytics().logEvent("homepage_viewed");
  }

  private async checkWalletLogin(): Promise<void> {
    const queryParams: any = queryString.parse(this.props.location.search); // wallet.kazan-kazan.com?token={extid}
    const walletToken: string = queryParams["token"]
      ? queryParams["token"]
      : queryParams["?token"];
    window.localStorage.setItem("token", walletToken);

    if (walletToken) {
      try {
        // const decoded: JwtDto = jwt_decode(walletToken);
        // await this.props.appStore.setOsType(decoded.osType);

        const { token } = await this.walletService.login(walletToken);
        await this.props.appStore.setToken(token);
        window.location.href = QuestionPage.url;
      } catch (e) {
        this.props.appStore.handleUnknownErrorModalVisibility(true);
        console.error(e);
      }
    }
  }

  render() {
    return <div id="home"></div>;
  }
}
